import useCollection from 'core/hooks/useCollection'

const useDocuments = (...args) => useCollection('documents', ...args)
export default useDocuments
